export default __webpack_public_path__ + "static/media/calendar.208fde86.svg";